import axios from "axios";
import router from "../router";

const ajax = axios.create({
  baseURL:
    process.env.VUE_APP_BASE_URL !== undefined
      ? `${process.env.VUE_APP_BASE_URL}/api`
      : ""
});

ajax.CancelToken = axios.CancelToken;
ajax.isCancel = axios.isCancel;

/*
 * Set default headers here
 */
ajax.defaults.headers.common["Content-Type"] = "application/json";

/*
 * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
 */
ajax.interceptors.request.use(
  config => {
    let token = localStorage.getItem("CWT_TOKEN");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

ajax.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status == 401) {
      window.localStorage.removeItem("CWT_TOKEN");
      window.localStorage.removeItem("CWT_USER");
      window.localStorage.removeItem("CWT_ROLE");
      window.localStorage.removeItem("CWT_ACCOUNT_TYPE");
      window.localStorage.removeItem("CWT_SHOW_PRICES");
      window.localStorage.removeItem("CWT_TAKE_PAYMENT");
      router.push({ name: "home", query: { login: true } });
    }
    return Promise.reject(error);
  }
);

export default ajax;
